<template>
  <p class="pf-text"
     ref="text"
     v-html="text"></p>
</template>

<script>
  export default {
    name: 'PFText',

    props: {
      text: {
        type: String,
        default: ''
      }
    },

    methods: {

    }
  }
</script>

<style lang="scss" scoped>
  .pf-text {

  }
</style>
